var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDugoutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8 A8 8 0 0 1 19 8",
    stroke: "#3DA8FC",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16 A8 8 0 0 1 5 16",
    stroke: "#F2B142",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2.2,
    fill: "#3DA8FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 2.2,
    fill: "#F2B142"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 22,
    fill: "#EAEEF5",
    fontFamily: "Almarai, system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "Dugout")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDugoutLogo);
export default __webpack_public_path__ + "static/media/dugout-logo.b64f6b800e2256eb888bbd2f0f1194b6.svg";
export { ForwardRef as ReactComponent };